var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiplePeople = function SvgMultiplePeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.88c-1.21 0-2.3.45-3.17 1.16 1.61.79 2.86 2.22 3.39 3.96H16v-.12c0-2.76-2.24-5-5-5m-6 2c-2.76 0-5 2.24-5 5V14h10v-.12c0-2.76-2.24-5-5-5m0-1.13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m6-2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"
  })));
};
export default SvgMultiplePeople;